<script setup lang="ts">
  import { IconLayers } from '@gat-ship/icons'
  import {
    FieldGroup,
    FormField,
    FormSubmit,
    InputGroupInput,
    Button,
    Modal,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalHeaderDescription,
    ModalHeaderIcon,
    ModalHeaderTitle,
    ModalSection,
    useForm,
    z
  } from '@gat-ship/vue-components'
  import { usePortCallTypes } from '../../../../composables/usePortCallTypes'

  const isOpen = defineModel<boolean>('open', { default: false })
  const service = usePortCallTypes()

  const schema = z.object({
    name: z.string().min(1, 'Required').max(60, 'Max 60 characters')
  })
  type FormValues = z.infer<typeof schema>

  const form = useForm({
    defaultValues: { name: '' } as FormValues,
    validators: { onChange: schema },
    onSubmit: async ({ value }) => {
      await service.add({ name: value.name })
      isOpen.value = false
    }
  })

  function showModal() {
    form.reset({ name: '' })
    isOpen.value = true
  }

  defineExpose({ showModal })
</script>

<template>
  <modal v-model:open="isOpen">
    <ModalHeader>
      <ModalHeaderTitle>
        <ModalHeaderIcon>
          <IconLayers class="size-5" :stroke-width="1.5" />
        </ModalHeaderIcon>
        Add portcall type
      </ModalHeaderTitle>
      <ModalHeaderDescription>
        Define a new port call classification (e.g. Cruise, Cargo operations).
      </ModalHeaderDescription>
    </ModalHeader>
    <ModalContent>
      <ModalSection>
        <FieldGroup>
          <FormField :form="form" name="name" label="Name" required>
            <template #default="{ field }">
              <InputGroupInput
                :id="field.name"
                :model-value="field.state.value ?? ''"
                autofocus
                @update:model-value="field.handleChange"
                @blur="field.handleBlur"
              />
            </template>
          </FormField>
        </FieldGroup>
      </ModalSection>
    </ModalContent>
    <ModalFooter>
      <FormSubmit :form="form" label="Add" :require-dirty="false" />
      <Button variant="ghost" @click="isOpen = false"> Cancel </Button>
    </ModalFooter>
  </modal>
</template>
